import { componentsClassNames } from "./classNames.default";
const defaultClassNames = {
    block: 'container--full gutter--m align--center',
    outer: 'container--full gutter--m align--center',
    inner: 'container--s'
};
const defaultClassNamesLarge = {
    ...defaultClassNames,
    inner: ''
};
const defaultClassNamesMedium = {
    ...defaultClassNames,
    inner: 'container--m'
};
const subscriptionClassNames = {
    ...defaultClassNames,
    clickablePrimary: 'black'
};
const textClassNames = {
    ...defaultClassNames,
    innerWithMedia: 'container--l'
};
const activitiesClassNames = {
    ...defaultClassNamesLarge,
    content: 'teaser--activity'
};
const gridItemsNames = {
    ...defaultClassNames,
    block: 'teaser--grid col-xs-12 col-sm-6 col-md-4'
};
const customComponentsClassNames = {
    ...componentsClassNames,
    jumbotron: {
        inner: 'container--full gutter--m align--center'
    }
};
const pagesClassNames = {
    newsDetailPage: {
        jumboType: 'large',
        jumboContent: 'description',
        introInner: 'container--full gutter--m align--center'
    },
    newsOverview: {
        inner: 'container--full gutter--m align--center'
    }
};
export const rdamCustomClassNames = {
    activity_cluster: activitiesClassNames,
    activities_selection_block: defaultClassNames,
    book: defaultClassNames,
    books: defaultClassNamesLarge,
    caroussel: defaultClassNamesLarge,
    collection_group: defaultClassNames,
    collection_item: defaultClassNames,
    collection_search_bar: defaultClassNames,
    collection: defaultClassNamesLarge,
    content_grid_item: defaultClassNames,
    content_grid_video: defaultClassNames,
    content_grid: defaultClassNamesLarge,
    core_activity_cluster: defaultClassNames,
    cta_block: defaultClassNames,
    datetime: defaultClassNames,
    expander_item: defaultClassNames,
    expanders: defaultClassNamesMedium,
    faq_collection: defaultClassNames,
    featured_content: defaultClassNames,
    formstack_block: defaultClassNames,
    grid_block: defaultClassNamesLarge,
    grid_items: gridItemsNames,
    highlight: defaultClassNames,
    iframe: defaultClassNames,
    images: defaultClassNames,
    inline_media: defaultClassNames,
    jumbotron: componentsClassNames.jumbotron,
    knop: defaultClassNames,
    location: defaultClassNames,
    media: defaultClassNamesLarge,
    newsDetailPage: pagesClassNames.newsDetailPage,
    newsletter_signup_form: defaultClassNames,
    newsOverview: pagesClassNames.newsOverview,
    opening_hours: defaultClassNames,
    page_grid: defaultClassNames,
    pager: componentsClassNames.pager,
    panorama: defaultClassNames,
    quote: defaultClassNamesMedium,
    recent_news: defaultClassNamesLarge,
    submenu_item: defaultClassNames,
    submenu: defaultClassNames,
    subscription_block: subscriptionClassNames,
    subscriptions: defaultClassNames,
    text: textClassNames,
    themakiezer_embed: defaultClassNames,
    tipped_activities_block: defaultClassNames,
    vacancy_overview: defaultClassNames,
    wordcloud_block: defaultClassNames
};
